'use client';

import React, { Fragment, useState } from 'react';
import parser from 'html-react-parser';
import moment from 'moment';
import { Button, Carousel, Col, Container, Modal, OverlayTrigger, Row, Table, Tooltip } from 'react-bootstrap';
import { useQuery } from 'react-query';
import { useParams } from 'next/navigation';
import { useTranslation } from '@/i18n/client';
import { Locale } from '../../../../../i18n-config';
import { useMediaQuery } from '@uidotdev/usehooks';
import Loading from '@/components/shared/Loading';
import ApiFailed from '@/components/shared/ApiFailed';
import Link from 'next/link';
import Image from 'next/image';
import { BiSolidCircle } from 'react-icons/bi';
import Section3 from '../../home/Section3';

//Updated
import archaeology from '../assets/archaeology.svg';
import art from '../assets/art.svg';
import bird from '../assets/bird.svg';
import boat from '../assets/boat.svg';
import camel from '../assets/camel.svg';
import camping from '../assets/camping.svg';
import cave from '../assets/cave.svg';
import cuisine from '../assets/cuisine.svg';
import culture from '../assets/culture.svg';
import cycling from '../assets/cycling.svg';
import desert from '../assets/desert.svg';
import diving from '../assets/diving.svg';
import dolphin from '../assets/dolphin.svg';
import eco_lodge from '../assets/eco-lodge.svg';
import family from '../assets/family.svg';
import fauna from '../assets/fauna.svg';
import festival from '../assets/festival.svg';
import flora from '../assets/flora.svg';
import fortress from '../assets/fortress.svg';
import geographic from '../assets/geographic.svg';
import geography from '../assets/geography.svg';
import group from '../assets/group.svg';
import hiking from '../assets/hiking.svg';
import island from '../assets/island.svg';
import kids from '../assets/kids.svg';
import mangrove from '../assets/mangrove.svg';
import medical from '../assets/medical.svg';
import mosque from '../assets/mosque.svg';
import mountain from '../assets/mountain.svg';
import national_park from '../assets/national-park.svg';
import nightsky from '../assets/nightsky.svg';
import nomad from '../assets/nomad.svg';
import off_road from '../assets/off-road.svg';
import photography from '../assets/photography.svg';
import picnic from '../assets/picnic.svg';
import rail from '../assets/rail.svg';
import reptiles from '../assets/reptiles.svg';
import sanddunes from '../assets/sanddunes.svg';
import seniors from '../assets/seniors.svg';
import ski from '../assets/ski.svg';
import student from '../assets/student.svg';
import turtle from '../assets/turtle.svg';
import unesco from '../assets/unesco.svg';
import village from '../assets/village.svg';
import yazd from '../assets/yazd.svg';

export interface ITour {
  id: number;
  type: string;
  banner_image: string;
  banner_thumbnail: string;
  map: string;
  map_thumbnail: string;
  language: number;
  title: string;
  tour_code: string;
  tags: Tag[];
  service_level: string;
  tour_images: TourImage[];
  physical_rating: string;
  overview: string;
  available_extra_services: AvailableExtraService[];
  included_services: IncludedService[];
  excluded_services: ExcludedService[];
  days: Day[];
  suggested_tour_data: SuggestedTourData;
  group_tours?: GroupTours[];
}

export interface Tag {
  id: number;
  name: string;
}

export interface TourImage {
  id: number;
  picture: string;
  thumbnail: string;
}

export interface AvailableExtraService {
  id: number;
  note: string;
  code: string;
}

export interface IncludedService {
  id: number;
  note: string;
  code: string;
}

export interface ExcludedService {
  id: number;
  note: string;
  code: string;
}

export interface Day {
  id: number;
  title: string;
  sequence: number;
  note: string;
  accommodation: number;
  accommodation_name: string;
  region_name: RegionName;
  night_region_name?: NightRegionName;
}

export interface RegionName {
  id: number;
  name: string;
}

export interface NightRegionName {
  id: number;
  name: string;
}

export interface SuggestedTourData {
  basis_group_size: number;
  basis_price: number;
}

export interface GroupTours {
  id: number;
  booking_deadline: string;
  start_date: string;
  price: number;
  group_size: number;
  departure_code: string;
}

moment.suppressDeprecationWarnings = true;

const styles = {
  color: { color: '#521231' },
  width_50: { width: '50px' },
  font_size_25: { fontSize: '25px' },
  font_size_30: { fontSize: '30px' },
  font_size_16: { fontSize: '16px' },
  tabItems: {
    fontSize: '18px',
    fontWeight: '600',
    color: '#521232',
    textDecoration: 'none',
  },
};

const Client = () => {
  const { lang, id } = useParams();
  const { t } = useTranslation(lang as Locale);

  const isMobile = useMediaQuery('only screen and (max-width : 768px)');

  const [modalShow, setModalShow] = React.useState(false);
  const [modalShow2, setModalShow2] = React.useState(false);
  const [first_modal, setFirstModal] = React.useState(false);
  const [intervals, setIntervals] = useState<any[]>([]);
  const [groupTours, setGroupTours] = useState<any[]>([]);
  const [min_price_grouptour, setMinPriceGroupTour] = useState(0);
  const [min_size_grouptour, setMinSizeGroupTour] = useState(0);
  const [galleryModal, setGalleryModal] = useState(false);

  const { isLoading, isError, isSuccess, data, refetch } = useQuery<ITour, string>(
    `tour_${id}`,
    () => fetch(`https://api.iranjourney.com/api/tour/tour_retrieve_delete/${id}`).then((res) => res.json()),
    {
      onSuccess: (res) => {
        var intervals: any[] = [];
        var _groupTours: any[] = [];

        if (typeof res.group_tours != 'undefined') {
          res.group_tours.forEach((value) => {
            var temp = moment(value.start_date);

            value.start_date = temp.format('MMM. D, yyyy');

            if (!intervals.includes(temp.year() + '-' + (temp.month() + 1))) {
              intervals.push(temp.year() + '-' + (temp.month() + 1));
              _groupTours.push([]);
            }
            _groupTours[intervals.length - 1].push(value);
          });

          let min = 9999;

          res.group_tours.map((grouptour) => {
            if (grouptour.price < min) {
              min = grouptour.price;
            }
          });

          setMinPriceGroupTour(min);

          let min_size = 9999;

          res.group_tours.map((grouptour) => {
            if (grouptour.group_size < min_size) {
              min_size = grouptour.group_size;
            }
          });

          setMinSizeGroupTour(min_size);
        }

        setGroupTours(_groupTours);
        setIntervals(intervals);
      },
    }
  );

  const tourAddRetrieve = useQuery(`tour-add-retrieve-${id}`, () =>
    fetch(`https://api.iranjourney.com/api/tour/tour_add_retrieve/${id}`).then((res) => res.json())
  );

  function MyVerticallyCenteredModalFirst(props) {
    return (
      <Modal {...props} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
        {/* <Modal.Header closeButton></Modal.Header> */}
        <Modal.Body>
          {/* <p style={styles.font_size_22} className="text-center py-0 seorgesb">
            Select at least one appsication ID* to proceed
          </p> */}
          <div
            style={
              {
                // border: "1px solid #e3e1e1",
                // boxShadow: "1px 2px 2px #e3e1e1",
              }
            }
            className="container mt-2 px-1 py-2"
          >
            <h3 className="text-center">The next steps</h3>
            <p className="text-left  ps-5 seorgesb">
              <span style={styles.color}>
                <BiSolidCircle className="me-2" />
              </span>
              {t('Creating an account / Sign up or Login ')}
            </p>
            <p className="text-left  ps-5 seorgesb">
              <span style={styles.color}>
                <BiSolidCircle className="me-2" />
              </span>
              {t('Create a new appsication ')}
            </p>
            <p className="text-left  ps-5 seorgesb">
              <span style={styles.color}>
                <BiSolidCircle className="me-2" />
              </span>
              {t('Review itinerary and services ')}
            </p>
            <p className="text-left  ps-5 seorgesb">
              <span style={styles.color}>
                <BiSolidCircle className="me-2" />
              </span>
              {t('Upsoading documents ')}
            </p>
            <p className="text-left  ps-5 seorgesb">
              <span style={styles.color}>
                <BiSolidCircle className="me-2" />
              </span>
              {t('Pay the deposit by invoice ')}
            </p>
            <p className="text-left  ps-5 seorgesb">
              <span style={styles.color}>
                <BiSolidCircle className="me-2" />
              </span>
              {t('Receiving confirmation and details by post few weeks before departure ')}
            </p>

            <button
              onClick={() => {
                setFirstModal(false);
                setModalShow(true);
              }}
              style={{
                color: '#4287f5',
                background: 'white',
                fontSize: '19px',
              }}
              className="btn seorgesb px-3  me-5 py-1 pull-right"
            >
              {t('Dismiss ')}
            </button>

            <br />
            <br />
          </div>
        </Modal.Body>
      </Modal>
    );
  }

  function MyVerticallyCenteredModal(props) {
    return (
      <Modal {...props} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
        {/* <Modal.Header closeButton></Modal.Header> */}
        <Modal.Body>
          {/* <p style={styles.font_size_22} className="text-center py-0 seorgesb">
            Select at least one appsication ID* to proceed
          </p> */}
          <p className="text-left py-2 seorgesb px-3">
            Psease select one appsication to proceed, Otherwise you may want to create newappsication for this order
            indepedently.
          </p>
          <p className="text-left seorge ps-3">
            <span className="ps-3">
              <input
                className="form-check-input"
                type="radio"
                name="radioNoLabel"
                id="radioNoLabel1"
                value=""
                aria-label="..."
              />
            </span>
            ANX5285TG2
          </p>
          <p className="text-left seorge ps-3">
            <span className="ps-3">
              <input
                className="form-check-input"
                type="radio"
                name="radioNoLabel"
                id="radioNoLabel1"
                value=""
                aria-label="..."
              />
            </span>
            OSN852DX
          </p>
          <button
            className="ps-3 pt-4 seorgesb"
            style={{
              border: 'none',
              color: '#0275d8',
              background: 'transparent',
            }}
          >
            + New Appsication
          </button>
          <div className="text-center">
            <button
              onClick={() => {
                setModalShow(false);
                setModalShow2(true);
              }}
              className="px-5 py-2 mt-3"
              style={{
                background: 'transparent',
                border: '1px solid #521231',
                borderRadius: '10px',
                fontWeight: 'bold',
                color: '#521231',
              }}
            >
              Submit order
            </button>
          </div>
        </Modal.Body>
      </Modal>
    );
  }

  function MyVerticallyCenteredModal2(props) {
    return (
      <Modal {...props} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
        {/* <Modal.Header closeButton></Modal.Header> */}
        <Modal.Body>
          <p className="text-left seorgesb">
            Thank you for your booking. <br />
          </p>
          <p className="text-left pt-1 pb-0 seorgesb">
            Psease follow up the reservation through &quot;My Appsications&quot; in your passenger panel. <br />
          </p>
          <p className="text-left pt-1 pb-0 seorgesb">
            One of our assisting agents will be assigned to your appsication in 48 hours.
          </p>
          <div className="text-center">
            <button
              onClick={() => {
                setModalShow2(false);
              }}
              className="px-5 py-2 mt-4 mx-5"
              style={{
                background: 'transparent',
                border: '1px solid #521231',
                borderRadius: '10px',
                fontWeight: 'bold',
                color: '#521231',
              }}
            >
              Go to home page
            </button>
            <button
              onClick={() => {
                setModalShow2(false);
              }}
              className="px-5 py-2 mt-4 mx-5"
              style={{
                background: 'transparent',
                border: '1px solid #521231',
                borderRadius: '10px',
                fontWeight: 'bold',
                color: '#521231',
              }}
            >
              Go to Passenger panel
            </button>
          </div>
        </Modal.Body>
      </Modal>
    );
  }

  const checkTagExisted = (tag_name: string) => {
    if (isSuccess && data && data.tags && data.tags.length > 0) {
      var all_tags = data.tags;

      for (var i = 0; i < all_tags.length; i++) {
        if (all_tags[i].name.toLowerCase().includes(tag_name.toLowerCase())) {
          return true;
        }
      }

      return false;
    } else return false;
  };

  const scrollToView = (destinationId) => {
    let targetSection = document.getElementById(destinationId);
    var headerOffset = 120;

    if (targetSection) {
      var elementPosition = targetSection.getBoundingClientRect().top;
      var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    }
  };

  if (isLoading) return <Loading />;

  if (isError) return <ApiFailed refetch={refetch} />;

  // If data is null, undefined, or missing required fields, show not found
  if (!data || !data.title || !data.overview) {
    return (
      <div className="tw-min-h-dvh tw-flex tw-flex-col tw-items-center tw-justify-center">
        <h1>Tour not found</h1>
        <p>The requested tour could not be found.</p>
      </div>
    );
  }

  return (
    <div className="each-tour-page">
      <React.Fragment>
        <div className="bg-img tw-relative md:tw-max-h-lvh md:tw-min-h-lvh">
          <Image
            src={`https://api.iranjourney.com${data?.banner_image}`}
            alt=""
            fill
            sizes="100vw"
            style={{ objectFit: 'cover' }}
            priority
          />
          <Container className="d-md-block d-none tw-z-20 tw-relative">
            <div className="py-md-5 py-3">
              <h1
                style={{
                  color: '#FFFFFF',
                  textShadow: '1px 1px #000000',
                  fontSize: '70px',
                  lineHeight: '1',
                }}
                className="text-left seorgesb textShadow"
              >
                {data?.title}
              </h1>

              <p
                style={{
                  color: '#FFFFFF',
                  textShadow: '1px 1px #000000',
                  fontSize: '70px',
                  lineHeight: '1',
                }}
                className="text-left seorgesb textShadow mt-sm-5 mt-2"
              >
                {data?.days.length} days
              </p>
            </div>
          </Container>
        </div>

        <Container className="d-md-none d-block">
          <div className="py-md-5 py-3">
            <p
              style={{
                fontSize: '20px',
                lineHeight: '1',
                color: '#000000',
              }}
              className="text-center seorgesb"
            >
              {data?.title}
            </p>

            <p
              style={{
                fontSize: '25px',
                lineHeight: '1',
                color: '#000000',
              }}
              className="text-center seorgesb mt-sm-5 mt-2 mb-0"
            >
              {data?.days.length} days
            </p>
          </div>
        </Container>

        <Container>
          <ul className="list-unstyled d-flex flex-wrap align-items-center mt-4 mb-0">
            <li className="pr-3 border-right">
              <span onClick={() => scrollToView('overviewSection')} style={{ ...styles.tabItems, cursor: 'pointer' }}>
                Overview
              </span>
            </li>
            {tourAddRetrieve.isSuccess &&
              tourAddRetrieve.data?.tour_add &&
              tourAddRetrieve.data?.tour_add[0] &&
              (tourAddRetrieve.data?.tour_add[0].video_file || tourAddRetrieve.data?.tour_add[0].video_url) && (
                <li className="px-3 border-right">
                  <span onClick={() => scrollToView('videoSection')} style={{ ...styles.tabItems, cursor: 'pointer' }}>
                    Video
                  </span>
                </li>
              )}
            <li className="px-3 border-right">
              <span onClick={() => scrollToView('itinerarySection')} style={{ ...styles.tabItems, cursor: 'pointer' }}>
                Full itinerary
              </span>
            </li>
            <li className="px-3 border-right">
              <span onClick={() => scrollToView('services')} style={{ ...styles.tabItems, cursor: 'pointer' }}>
                Services
              </span>
            </li>
            {typeof data?.group_tours !== 'undefined' && data?.group_tours.length !== 0 && (
              <li className="px-3">
                <span onClick={() => scrollToView('departures')} style={{ ...styles.tabItems, cursor: 'pointer' }}>
                  Departures
                </span>
              </li>
            )}
          </ul>

          <div className="tw-sticky">
            <Row className="mt-md-5 mt-3 position-relative">
              <Col md={7} id="overviewSection">
                <p className="seorgesb text-left">{t('Overview ')}</p>
                <p className="seorge text-left ps-4">{data?.overview}</p>

                <Row className="mb-md-5 mb-3">
                  <Col md={6} xs={12}>
                    <p style={styles.tabItems} className="seorgesb text-left mt-2 mb-0">
                      {t('Service Level ')}
                    </p>
                    <span>
                      <p className="seorge text-left ps-4">
                        {data?.service_level}

                        <span className="ps-2">
                          <OverlayTrigger
                            key={'left'}
                            placement={'right'}
                            overlay={
                              <Tooltip id={`tooltip-${'left'}`}>
                                {data?.service_level.toLowerCase() === 'tourist class' && (
                                  <span>
                                    Itineraries in the level of “Tourist Class” are fully psanned, with some free time,
                                    and have accommodations in a combination of 3 to 4-star hotels through the journey.
                                    Accommodations are comfortable, well-located, and modest. Regarding ground
                                    transportation, you will travel by a chartered tourist class sedan, van, or bus for
                                    the whole trip but all domestic flights will be economy class. Trips are led mostly
                                    by one guide for the whole trip. Meals will be half board (Breakfast + Lunch/Dinner)
                                    unless you ask in the customization step.
                                  </span>
                                )}

                                {data?.service_level.toLowerCase() === 'basic' && (
                                  <span>
                                    “Basic” level in a tour means that you will receive the economy quality of each
                                    element of the trip, which is available, obviously, you cannot expect higher or more
                                    services which reaches to a 3-star hotel in accommodation element for exampse. There
                                    is maybe one night in the tent, village stay or eco-lodges. Trips are led by dynamic
                                    local guides. Mostly breakfasts are included, and transportation is provided for
                                    included excursions. Regarding transportation, you may travel with public
                                    transportation between cities and locations.
                                  </span>
                                )}

                                {data?.service_level.toLowerCase() === 'wild camping' && (
                                  <span>
                                    At the time of using the “Wild Camping” phrase, it means that you will stay at least
                                    one night in a tent in nature and outdoor. We usually arrange other nights of such
                                    trips with a combination of 3 to 4-star hotels which can be recognized by the
                                    itinerary or customizing upon your request. Some meals such as breakfast and lunch
                                    or dinner, and activities are included, regarding ground transportation, your major
                                    segments will run with a chartered sedan, van, or off-road vehicles.
                                  </span>
                                )}

                                {data?.service_level.toLowerCase() === 'local & eco lodge' && (
                                  <span>
                                    Local eco-lodges are used when you will stay at least one night in an exotic
                                    property, or rural house, Villa, cave accommodations, etc. Itineraries are fully
                                    psanned, with some free time; we usually arrange other nights of such trips with a
                                    combination of 3 to 4-star hotels which can be recognized by the itinerary or
                                    customizing upon your request. Urban accommodations are comfortable, well-located,
                                    and modest. Regarding ground transportation, you will travel with a chartered sedan
                                    or van for the whole trip. you will travel by a chartered tourist class sedan, van,
                                    or bus for the whole trip, but all domestic flights will be economy class. Trips are
                                    led by dynamic local guides or one guide for the whole trip. Meals will be half
                                    board (Breakfast + Lunch/Dinner) unless you ask in the customization step.
                                  </span>
                                )}

                                {data?.service_level.toLowerCase() === 'premium class' && (
                                  <span>
                                    Itineraries in the level of “Premium Class” are fully psanned, with some free time
                                    and accommodations are high-end or best available in a combination with 4 to 5-star
                                    hotels through the journey. Regarding ground transportation, you will travel by a
                                    chartered business class sedan, van, or bus for the whole trip but all domestic
                                    flights will be economy class. Meals will be full board (Breakfast + Lunch +
                                    Dinner). Trips led by an Iran Journey expert, top guides, or an expedition team.
                                  </span>
                                )}
                              </Tooltip>
                            }
                          >
                            <span>
                              <i
                                style={{ fontSize: '20px', color: '#949292' }}
                                className="fa fa-question-circle mt-3"
                              ></i>
                            </span>
                          </OverlayTrigger>
                        </span>
                      </p>
                    </span>
                  </Col>

                  <Col md={6} xs={12}>
                    <p style={styles.tabItems} className="seorgesb text-left mt-2 mb-0">
                      {t('Entry gateway ')}
                    </p>
                    <span>
                      <p className="seorge text-left ps-4">
                        {tourAddRetrieve.isSuccess &&
                          tourAddRetrieve.data?.tour_add &&
                          tourAddRetrieve.data?.tour_add[0] &&
                          tourAddRetrieve.data?.tour_add[0].entry_gateway && (
                            <span>{tourAddRetrieve.data?.tour_add[0].entry_gateway}</span>
                          )}
                      </p>
                    </span>
                  </Col>

                  <Col md={6} xs={12}>
                    <p style={styles.tabItems} className="seorgesb text-left mt-2 mb-0">
                      {t('Physical Rating ')}
                    </p>
                    <p className="seorge text-left ps-4">
                      {data?.physical_rating}

                      <span className="ps-2">
                        <OverlayTrigger
                          key={'left'}
                          placement={'right'}
                          overlay={
                            <Tooltip id={`tooltip-${'left'}`}>
                              {data?.physical_rating.toLowerCase() === 'easy' && (
                                <span>
                                  Travelers should be in good health and comfortable walking or standing for at least a
                                  few hours. Daily activities may include walking, visiting museums, mosques, and very
                                  easy hikes; If you have any difficulties with your leg, knee, breathing problems,
                                  allergic or any chronic diseases, we strongly recommend you inform us, for improving
                                  the care level and preparing for emergencies.
                                </span>
                              )}

                              {data?.physical_rating.toLowerCase() === 'moderate' && (
                                <span>
                                  Travelers should be in good health and comfortable walking or standing for extended
                                  periods of time, maybe with a backpack for a distance. Daily activities may include
                                  walking, Off-road driving, limited access to WC, urban facility; and some days will
                                  have more physical activities such as short hikes, or biking, etc. The details must be
                                  checked with our staff before making a booking.
                                </span>
                              )}

                              {data?.physical_rating.toLowerCase() === 'difficult' && (
                                <span>
                                  Travelers should be in good health and comfortable walking or standing for extended
                                  periods of time, maybe with a backpack for a distance. Daily activities may include
                                  walking, increasing altitude, Off-road drives, limited access to WC, urban facility,
                                  medical center, water, and food suppsy; there is also the chance of technical problems
                                  with vehicles, mules, or facing bad weather; some days will have more physical
                                  activities such as longer hikes, etc. The details must be checked with our staff
                                  before making a booking.
                                </span>
                              )}
                            </Tooltip>
                          }
                        >
                          <span>
                            <i
                              style={{ fontSize: '20px', color: '#949292' }}
                              className="fa fa-question-circle mt-3"
                            ></i>
                          </span>
                        </OverlayTrigger>
                      </span>
                    </p>
                  </Col>

                  <Col md={6} xs={12}>
                    <p style={styles.tabItems} className="seorgesb text-left mt-2 mb-0">
                      {t('Exit gateway ')}
                    </p>
                    <span>
                      <p className="seorge text-left ps-4">
                        {tourAddRetrieve.isSuccess &&
                          tourAddRetrieve.data?.tour_add &&
                          tourAddRetrieve.data?.tour_add[0] &&
                          tourAddRetrieve.data?.tour_add[0].exit_gateway && (
                            <span>{tourAddRetrieve.data?.tour_add[0].exit_gateway}</span>
                          )}
                      </p>
                    </span>
                  </Col>

                  <Col md={6} xs={12}>
                    <p style={styles.tabItems} className="seorgesb text-left mt-2 mb-0">
                      {t('Transportation ')}
                    </p>
                    <span>
                      <p className="seorge text-left ps-4">
                        {tourAddRetrieve.isSuccess &&
                          tourAddRetrieve.data?.tour_add &&
                          tourAddRetrieve.data?.tour_add[0] &&
                          tourAddRetrieve.data?.tour_add[0].transportation && (
                            <span>{tourAddRetrieve.data?.tour_add[0].transportation}</span>
                          )}
                      </p>
                    </span>
                  </Col>

                  <Col md={6} xs={12}>
                    <p style={styles.tabItems} className="seorgesb text-left mt-2 mb-0">
                      {t('Meals ')}
                    </p>
                    <span>
                      <p className="seorge text-left ps-4">
                        {tourAddRetrieve.isSuccess &&
                          tourAddRetrieve.data?.tour_add &&
                          tourAddRetrieve.data?.tour_add[0] &&
                          tourAddRetrieve.data?.tour_add[0].meals && (
                            <span>{tourAddRetrieve.data?.tour_add[0].meals}</span>
                          )}
                      </p>
                    </span>
                  </Col>
                </Row>

                {!isMobile && (
                  <Fragment>
                    <p style={styles.tabItems} className="seorgesb text-left mt-2">
                      {t('Tags ')}
                    </p>
                    <div className="text-left mt-2 tw-flex tw-gap-2 tw-flex-wrap">
                      {typeof data?.tags != 'undefined' &&
                        data?.tags.map((tag, index) => (
                          <div key={index}>
                            <Link
                              style={{
                                textDecoration: 'none',
                                color: 'black',
                              }}
                              href={`/tours?style=${tag.name}`}
                            >
                              <span
                                style={{
                                  background: 'white',
                                  borderRadius: '3px',
                                  border: '1px solid #bfbfbf',
                                }}
                                className="px-2 ml-2"
                              >
                                {tag.name}
                              </span>
                            </Link>
                          </div>
                        ))}
                    </div>
                  </Fragment>
                )}
              </Col>
              <Col md={5} className="position-sticky" style={{ top: 120 }}>
                <div>
                  <br />
                  <br />
                  <div
                    className="py-4 px-4 me-4 position-relative"
                    style={
                      isMobile
                        ? {
                            background: '#ededed',
                            width: '100%',
                            border: '1px solid #e3e1e1',
                            boxShadow: '1px 2px 2px #e3e1e1',
                          }
                        : {
                            background: '#ededed',
                            width: '100%',
                            border: '1px solid #e3e1e1',
                            boxShadow: '1px 2px 2px #e3e1e1',
                          }
                    }
                  >
                    {tourAddRetrieve.isSuccess &&
                      tourAddRetrieve.data?.tour_add &&
                      tourAddRetrieve.data?.tour_add[0] &&
                      tourAddRetrieve.data?.tour_add[0].badage && (
                        <div
                          className="tour-badage p-2"
                          style={{
                            position: 'absolute',
                            right: '30px',
                            top: '0',
                            fontSize: '30px',
                            backgroundColor: tourAddRetrieve.data?.tour_add[0].badage_cadre_color || '',
                            color: tourAddRetrieve.data?.tour_add[0].badage_text_color || '',
                          }}
                        >
                          {tourAddRetrieve.data?.tour_add[0].badage}
                        </div>
                      )}
                    <Row className="pt-0 mt-0">
                      <div
                        className={`embeds ${
                          tourAddRetrieve.isSuccess &&
                          tourAddRetrieve.data?.tour_add &&
                          tourAddRetrieve.data?.tour_add[0] &&
                          tourAddRetrieve.data?.tour_add[0].badage
                            ? 'has-badge'
                            : ''
                        }`}
                      >
                        {checkTagExisted('archaeology') && (
                          <Image
                            width={50}
                            height={50}
                            style={styles.width_50}
                            className="ml-1"
                            src={archaeology}
                            alt="archaeology"
                          />
                        )}

                        {checkTagExisted('art') && (
                          <Image width={50} height={50} style={styles.width_50} className="ml-1" src={art} alt="art" />
                        )}

                        {checkTagExisted('bird') && (
                          <Image
                            width={50}
                            height={50}
                            style={styles.width_50}
                            className="ml-1"
                            src={bird}
                            alt="bird"
                          />
                        )}

                        {checkTagExisted('boat') && (
                          <Image
                            width={50}
                            height={50}
                            style={styles.width_50}
                            className="ml-1"
                            src={boat}
                            alt="boat"
                          />
                        )}

                        {checkTagExisted('camel') && (
                          <Image
                            width={50}
                            height={50}
                            style={styles.width_50}
                            className="ml-1"
                            src={camel}
                            alt="camel"
                          />
                        )}

                        {checkTagExisted('camp') && (
                          <Image
                            width={50}
                            height={50}
                            style={styles.width_50}
                            className="ml-1"
                            src={camping}
                            alt="camping"
                          />
                        )}

                        {checkTagExisted('cave') && (
                          <Image
                            width={50}
                            height={50}
                            style={styles.width_50}
                            className="ml-1"
                            src={cave}
                            alt="cave"
                          />
                        )}

                        {checkTagExisted('cuisine') && (
                          <Image
                            width={50}
                            height={50}
                            style={styles.width_50}
                            className="ml-1"
                            src={cuisine}
                            alt="cuisine"
                          />
                        )}

                        {checkTagExisted('culture') && (
                          <Image
                            width={50}
                            height={50}
                            style={styles.width_50}
                            className="ml-1"
                            src={culture}
                            alt="culture"
                          />
                        )}

                        {checkTagExisted('cycling') && (
                          <Image
                            width={50}
                            height={50}
                            style={styles.width_50}
                            className="ml-1"
                            src={cycling}
                            alt="cycling"
                          />
                        )}

                        {checkTagExisted('desert') && (
                          <Image
                            width={50}
                            height={50}
                            style={styles.width_50}
                            className="ml-1"
                            src={desert}
                            alt="desert"
                          />
                        )}

                        {checkTagExisted('diving') && (
                          <Image
                            width={50}
                            height={50}
                            style={styles.width_50}
                            className="ml-1"
                            src={diving}
                            alt="diving"
                          />
                        )}

                        {checkTagExisted('dolphin') && (
                          <Image
                            width={50}
                            height={50}
                            style={styles.width_50}
                            className="ml-1"
                            src={dolphin}
                            alt="dolphin"
                          />
                        )}

                        {checkTagExisted('lodge') && (
                          <Image
                            width={50}
                            height={50}
                            style={styles.width_50}
                            className="ml-1"
                            src={eco_lodge}
                            alt="eco_lodge"
                          />
                        )}

                        {checkTagExisted('family') && (
                          <Image
                            width={50}
                            height={50}
                            style={styles.width_50}
                            className="ml-1"
                            src={family}
                            alt="family"
                          />
                        )}

                        {checkTagExisted('fauna') && (
                          <Image
                            width={50}
                            height={50}
                            style={styles.width_50}
                            className="ml-1"
                            src={fauna}
                            alt="fauna"
                          />
                        )}

                        {checkTagExisted('festival') && (
                          <Image
                            width={50}
                            height={50}
                            style={styles.width_50}
                            className="ml-1"
                            src={festival}
                            alt="festival"
                          />
                        )}

                        {checkTagExisted('flora') && (
                          <Image
                            width={50}
                            height={50}
                            style={styles.width_50}
                            className="ml-1"
                            src={flora}
                            alt="flora"
                          />
                        )}

                        {checkTagExisted('fortress') && (
                          <Image
                            width={50}
                            height={50}
                            style={styles.width_50}
                            className="ml-1"
                            src={fortress}
                            alt="fortress"
                          />
                        )}

                        {checkTagExisted('geographic') && (
                          <Image
                            width={50}
                            height={50}
                            style={styles.width_50}
                            className="ml-1"
                            src={geographic}
                            alt="geographic"
                          />
                        )}

                        {checkTagExisted('geography') && (
                          <Image
                            width={50}
                            height={50}
                            style={styles.width_50}
                            className="ml-1"
                            src={geography}
                            alt="geography"
                          />
                        )}

                        {checkTagExisted('group') && (
                          <Image
                            width={50}
                            height={50}
                            style={styles.width_50}
                            className="ml-1"
                            src={group}
                            alt="group"
                          />
                        )}

                        {checkTagExisted('hiking') && (
                          <Image
                            width={50}
                            height={50}
                            style={styles.width_50}
                            className="ml-1"
                            src={hiking}
                            alt="hiking"
                          />
                        )}

                        {checkTagExisted('island') && (
                          <Image
                            width={50}
                            height={50}
                            style={styles.width_50}
                            className="ml-1"
                            src={island}
                            alt="island"
                          />
                        )}

                        {checkTagExisted('kids') && (
                          <Image
                            width={50}
                            height={50}
                            style={styles.width_50}
                            className="ml-1"
                            src={kids}
                            alt="kids"
                          />
                        )}

                        {checkTagExisted('mangrove') && (
                          <Image
                            width={50}
                            height={50}
                            style={styles.width_50}
                            className="ml-1"
                            src={mangrove}
                            alt="mangrove"
                          />
                        )}

                        {checkTagExisted('medical') && (
                          <Image
                            width={50}
                            height={50}
                            style={styles.width_50}
                            className="ml-1"
                            src={medical}
                            alt="medical"
                          />
                        )}

                        {checkTagExisted('mosque') && (
                          <Image
                            width={50}
                            height={50}
                            style={styles.width_50}
                            className="ml-1"
                            src={mosque}
                            alt="mosque"
                          />
                        )}

                        {checkTagExisted('mountain') && (
                          <Image
                            width={50}
                            height={50}
                            style={styles.width_50}
                            className="ml-1"
                            src={mountain}
                            alt="mountain"
                          />
                        )}

                        {checkTagExisted('park') && (
                          <Image
                            width={50}
                            height={50}
                            style={styles.width_50}
                            className="ml-1"
                            src={national_park}
                            alt="national_park"
                          />
                        )}

                        {checkTagExisted('night') && (
                          <Image
                            width={50}
                            height={50}
                            style={styles.width_50}
                            className="ml-1"
                            src={nightsky}
                            alt="nightsky"
                          />
                        )}

                        {checkTagExisted('nomad') && (
                          <Image
                            width={50}
                            height={50}
                            style={styles.width_50}
                            className="ml-1"
                            src={nomad}
                            alt="nomad"
                          />
                        )}

                        {checkTagExisted('off-road') && (
                          <Image
                            width={50}
                            height={50}
                            style={styles.width_50}
                            className="ml-1"
                            src={off_road}
                            alt="off_road"
                          />
                        )}

                        {checkTagExisted('photo') && (
                          <Image
                            width={50}
                            height={50}
                            style={styles.width_50}
                            className="ml-1"
                            src={photography}
                            alt="photography"
                          />
                        )}

                        {checkTagExisted('picnic') && (
                          <Image
                            width={50}
                            height={50}
                            style={styles.width_50}
                            className="ml-1"
                            src={picnic}
                            alt="picnic"
                          />
                        )}

                        {checkTagExisted('rail') && (
                          <Image
                            width={50}
                            height={50}
                            style={styles.width_50}
                            className="ml-1"
                            src={rail}
                            alt="rail"
                          />
                        )}

                        {checkTagExisted('reptiles') && (
                          <Image
                            width={50}
                            height={50}
                            style={styles.width_50}
                            className="ml-1"
                            src={reptiles}
                            alt="reptiles"
                          />
                        )}

                        {checkTagExisted('sand') && (
                          <Image
                            width={50}
                            height={50}
                            style={styles.width_50}
                            className="ml-1"
                            src={sanddunes}
                            alt="sanddunes"
                          />
                        )}

                        {checkTagExisted('senior') && (
                          <Image
                            width={50}
                            height={50}
                            style={styles.width_50}
                            className="ml-1"
                            src={seniors}
                            alt="seniors"
                          />
                        )}

                        {checkTagExisted('ski') && (
                          <Image width={50} height={50} style={styles.width_50} className="ml-1" src={ski} alt="ski" />
                        )}

                        {checkTagExisted('student') && (
                          <Image
                            width={50}
                            height={50}
                            style={styles.width_50}
                            className="ml-1"
                            src={student}
                            alt="student"
                          />
                        )}

                        {checkTagExisted('turtle') && (
                          <Image
                            width={50}
                            height={50}
                            style={styles.width_50}
                            className="ml-1"
                            src={turtle}
                            alt="turtle"
                          />
                        )}

                        {checkTagExisted('unesco') && (
                          <Image
                            width={50}
                            height={50}
                            style={styles.width_50}
                            className="ml-1"
                            src={unesco}
                            alt="unesco"
                          />
                        )}

                        {checkTagExisted('village') && (
                          <Image
                            width={50}
                            height={50}
                            style={styles.width_50}
                            className="ml-1"
                            src={village}
                            alt="village"
                          />
                        )}

                        {checkTagExisted('Yazd') && (
                          <Image
                            width={50}
                            height={50}
                            style={styles.width_50}
                            className="ml-1"
                            src={yazd}
                            alt="yazd"
                          />
                        )}
                      </div>
                    </Row>
                    <Row>
                      <Col xs={4}>
                        <p style={{ fontSize: '80px', color: '#521232' }} className="test pt-4 ps-4 mt-2">
                          {data?.days.length}
                          <span
                            className="font-weight-bold ps-1 montserrat"
                            style={{ fontSize: '19px', color: 'black' }}
                          >
                            {t('Days ')}
                          </span>
                        </p>
                      </Col>
                      <Col xs={2}></Col>
                    </Row>
                    <h2 style={{ fontSize: '40px', lineHeight: '1.1' }} className="text-left montserrat my-4">
                      {data?.title}
                    </h2>
                    <p className="py-0 my-0 seorgesb" style={{ color: '#4c5f56', fontSize: '20px' }}>
                      {t('Basis group size: ')}
                      {typeof data?.suggested_tour_data !== 'undefined'
                        ? data?.suggested_tour_data?.basis_group_size
                        : min_size_grouptour}
                      <span className="tw-ml-2">{t('Persons ')}</span>
                    </p>
                    <p style={{ color: '#4c5f56', fontSize: '20px' }} className="text-left seorgesb mb-2 mt-2">
                      {t('From ')}
                      <span className="seorgesb ps-2" style={{ color: '#4c5f56' }}>
                        $
                        <span>
                          {typeof data?.suggested_tour_data !== 'undefined'
                            ? data?.suggested_tour_data?.basis_price
                            : min_price_grouptour}
                        </span>
                        <span style={styles.font_size_30} className="tw-ml-2">
                          USD
                        </span>
                      </span>
                    </p>

                    <div className="row py-0 my-0">
                      <div className="col-sm-6">
                        <p style={{ color: '#4c5f56', fontSize: '20px' }} className="text-left montserrat my-4">
                          {t('Trip Code: ')} {data?.tour_code}
                        </p>
                      </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-between">
                      <Link
                        className="text-decoration-none btn seorgesb px-3 me-5 py-1"
                        href={'/tailor-made-iran-tours'}
                        style={{
                          color: 'white',
                          background: '#511232',
                          fontSize: '19px',
                        }}
                      >
                        {t('Inquire Now ')}
                      </Link>

                      {tourAddRetrieve.isSuccess &&
                        tourAddRetrieve.data?.tour_add &&
                        tourAddRetrieve.data?.tour_add[0] &&
                        tourAddRetrieve.data?.tour_add[0].brochure && (
                          <a
                            href={`https://api.iranjourney.com/${tourAddRetrieve.data?.tour_add[0].brochure}`}
                            download
                            target="_blank"
                            className="text-decoration-none btn seorgesb px-3 py-1"
                            style={{
                              color: 'gray',
                              background: 'transparent',
                              fontSize: '19px',
                              borderColor: '#521232',
                            }}
                          >
                            Download
                          </a>
                        )}
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>

          <hr className="my-3" />

          {tourAddRetrieve.isSuccess &&
            tourAddRetrieve.data?.tour_add &&
            tourAddRetrieve.data?.tour_add[0] &&
            (tourAddRetrieve.data?.tour_add[0].video_file || tourAddRetrieve.data?.tour_add[0].video_url) && (
              <>
                <div id="videoSection">
                  {tourAddRetrieve.data?.tour_add[0].video_file ? (
                    <video className="w-100">
                      <source
                        src={
                          tourAddRetrieve.data?.tour_add[0].video_file !== null
                            ? `https://api.iranjourney.com/${tourAddRetrieve.data?.tour_add[0].video_file}`
                            : tourAddRetrieve.data?.tour_add[0].video_url
                        }
                      />
                      Your browser does not support video
                    </video>
                  ) : (
                    <div className="text-center w-100">{parser(tourAddRetrieve.data?.tour_add[0].video_url)}</div>
                  )}
                </div>
                <hr className="my-3" />
              </>
            )}

          {tourAddRetrieve.isSuccess &&
            tourAddRetrieve.data?.tour_pic_list &&
            tourAddRetrieve.data?.tour_pic_list.length > 0 && (
              <div className="each-tour-gallery">
                {!isMobile ? (
                  <Row>
                    {tourAddRetrieve.data?.tour_pic_list[0].image_1 && (
                      <Col md={8} className="position-relative image-item ">
                        <div className="overlay" onClick={() => setGalleryModal(true)}>
                          <span style={{ textShadow: '1px 1px 2px black' }}>+ More</span>
                        </div>
                        <img
                          src={`https://api.iranjourney.com/${tourAddRetrieve.data?.tour_pic_list[0].image_1}`}
                          className="w-100 h-100 img-fluid"
                          height={120}
                        />
                      </Col>
                    )}
                    <Col md={4} className="p-0">
                      <Row>
                        {tourAddRetrieve.data?.tour_pic_list[0].image_2 && (
                          <Col md={12} className="mb-1 position-relative image-item px-1">
                            <div className="overlay" onClick={() => setGalleryModal(true)}>
                              <span style={{ textShadow: '1px 1px 2px black' }}>+ More</span>
                            </div>
                            <img
                              src={`https://api.iranjourney.com/${tourAddRetrieve.data?.tour_pic_list[0].image_2}`}
                              className="w-100 h-100 img-fluid"
                              height={60}
                            />
                          </Col>
                        )}
                        {tourAddRetrieve.data?.tour_pic_list[0].image_3 && (
                          <Col md={12} className="position-relative image-item px-1">
                            <div className="overlay" onClick={() => setGalleryModal(true)}>
                              <span style={{ textShadow: '1px 1px 2px black' }}>+ More</span>
                            </div>
                            <img
                              src={`https://api.iranjourney.com/${tourAddRetrieve.data?.tour_pic_list[0].image_3}`}
                              className="w-100 h-100 img-fluid"
                              height={60}
                            />
                          </Col>
                        )}
                        {/* {tourAddRetrieve.data?.tour_pic_list[0].image_4 && (
                            <Col
                              md={6}
                              className="mb-3 position-relative image-item"
                            >
                              <div
                                className="overlay"
                                onClick={() => setGalleryModal(true)}
                              >
                                View
                              </div>
                              <img
                                src={`https://api.iranjourney.com/${tourAddRetrieve.data?.tour_pic_list[0].image_4}`}
                                className="w-100 img-fluid"
                                height={60}
                              />
                            </Col>
                          )}
                          {tourAddRetrieve.data?.tour_pic_list[0].image_5 && (
                            <Col
                              md={6}
                              className="mb-3 position-relative image-item"
                            >
                              <div
                                className="overlay"
                                onClick={() => setGalleryModal(true)}
                              >
                                View
                              </div>
                              <img
                                src={`https://api.iranjourney.com/${tourAddRetrieve.data?.tour_pic_list[0].image_5}`}
                                className="w-100 img-fluid"
                                height={60}
                              />
                            </Col>
                          )} */}
                      </Row>
                    </Col>
                  </Row>
                ) : (
                  <Carousel>
                    {tourAddRetrieve.isSuccess && tourAddRetrieve.data?.tour_pic_list[0].image_1 && (
                      <Carousel.Item>
                        <img
                          src={`https://api.iranjourney.com/${tourAddRetrieve.data?.tour_pic_list[0].image_1}`}
                          className="img-fluid"
                        />
                      </Carousel.Item>
                    )}
                    {tourAddRetrieve.isSuccess && tourAddRetrieve.data?.tour_pic_list[0].image_2 && (
                      <Carousel.Item>
                        <img
                          src={`https://api.iranjourney.com/${tourAddRetrieve.data?.tour_pic_list[0].image_2}`}
                          className="img-fluid"
                        />
                      </Carousel.Item>
                    )}
                    {tourAddRetrieve.isSuccess && tourAddRetrieve.data?.tour_pic_list[0].image_3 && (
                      <Carousel.Item>
                        <img
                          src={`https://api.iranjourney.com/${tourAddRetrieve.data?.tour_pic_list[0].image_3}`}
                          className="img-fluid"
                        />
                      </Carousel.Item>
                    )}
                    {tourAddRetrieve.isSuccess && tourAddRetrieve.data?.tour_pic_list[0].image_4 && (
                      <Carousel.Item>
                        <img
                          src={`https://api.iranjourney.com/${tourAddRetrieve.data?.tour_pic_list[0].image_4}`}
                          className="img-fluid"
                        />
                      </Carousel.Item>
                    )}
                    {tourAddRetrieve.isSuccess && tourAddRetrieve.data?.tour_pic_list[0].image_5 && (
                      <Carousel.Item>
                        <img
                          src={`https://api.iranjourney.com/${tourAddRetrieve.data?.tour_pic_list[0].image_5}`}
                          className="img-fluid"
                        />
                      </Carousel.Item>
                    )}
                    {tourAddRetrieve.isSuccess && tourAddRetrieve.data?.tour_pic_list[0].image_6 && (
                      <Carousel.Item>
                        <img
                          src={`https://api.iranjourney.com/${tourAddRetrieve.data?.tour_pic_list[0].image_6}`}
                          className="img-fluid"
                        />
                      </Carousel.Item>
                    )}
                    {tourAddRetrieve.isSuccess && tourAddRetrieve.data?.tour_pic_list[0].image_7 && (
                      <Carousel.Item>
                        <img
                          src={`https://api.iranjourney.com/${tourAddRetrieve.data?.tour_pic_list[0].image_7}`}
                          className="img-fluid"
                        />
                      </Carousel.Item>
                    )}
                    {tourAddRetrieve.isSuccess && tourAddRetrieve.data?.tour_pic_list[0].image_8 && (
                      <Carousel.Item>
                        <img
                          src={`https://api.iranjourney.com/${tourAddRetrieve.data?.tour_pic_list[0].image_8}`}
                          className="img-fluid"
                        />
                      </Carousel.Item>
                    )}
                    {tourAddRetrieve.isSuccess && tourAddRetrieve.data?.tour_pic_list[0].image_9 && (
                      <Carousel.Item>
                        <img
                          src={`https://api.iranjourney.com/${tourAddRetrieve.data?.tour_pic_list[0].image_9}`}
                          className="img-fluid"
                        />
                      </Carousel.Item>
                    )}
                    {tourAddRetrieve.isSuccess && tourAddRetrieve.data?.tour_pic_list[0].image_10 && (
                      <Carousel.Item>
                        <img
                          src={`https://api.iranjourney.com/${tourAddRetrieve.data?.tour_pic_list[0].image_10}`}
                          className="img-fluid"
                        />
                      </Carousel.Item>
                    )}
                    {tourAddRetrieve.isSuccess && tourAddRetrieve.data?.tour_pic_list[0].image_11 && (
                      <Carousel.Item>
                        <img
                          src={`https://api.iranjourney.com/${tourAddRetrieve.data?.tour_pic_list[0].image_11}`}
                          className="img-fluid"
                        />
                      </Carousel.Item>
                    )}
                    {tourAddRetrieve.isSuccess && tourAddRetrieve.data?.tour_pic_list[0].image_12 && (
                      <Carousel.Item>
                        <img
                          src={`https://api.iranjourney.com/${tourAddRetrieve.data?.tour_pic_list[0].image_12}`}
                          className="img-fluid"
                        />
                      </Carousel.Item>
                    )}
                    {tourAddRetrieve.isSuccess && tourAddRetrieve.data?.tour_pic_list[0].image_13 && (
                      <Carousel.Item>
                        <img
                          src={`https://api.iranjourney.com/${tourAddRetrieve.data?.tour_pic_list[0].image_13}`}
                          className="img-fluid"
                        />
                      </Carousel.Item>
                    )}
                    {tourAddRetrieve.isSuccess && tourAddRetrieve.data?.tour_pic_list[0].image_14 && (
                      <Carousel.Item>
                        <img
                          src={`https://api.iranjourney.com/${tourAddRetrieve.data?.tour_pic_list[0].image_14}`}
                          className="img-fluid"
                        />
                      </Carousel.Item>
                    )}
                    {tourAddRetrieve.isSuccess && tourAddRetrieve.data?.tour_pic_list[0].image_15 && (
                      <Carousel.Item>
                        <img
                          src={`https://api.iranjourney.com/${tourAddRetrieve.data?.tour_pic_list[0].image_15}`}
                          className="img-fluid"
                        />
                      </Carousel.Item>
                    )}
                  </Carousel>
                )}

                <hr className="my-3" />
              </div>
            )}

          <div className="position-relative">
            <div
              className="position-sticky mb-3"
              style={{
                top: !localStorage.getItem('emergency_alert') ? 50 : 100,
                zIndex: 98,
              }}
            >
              <div
                className="w-100 p-3 d-flex flex-sm-row flex-column flex-wrap align-items-sm-center justify-content-between"
                style={{
                  backgroundColor: '#f5f5f5',
                  boxShadow: '0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23)',
                  gap: '12px',
                }}
              >
                <h3 className="mb-0" style={{ color: '#5a5c63' }}>
                  {data?.title}
                </h3>
                <span style={{ fontSize: '26px' }}>{data?.days.length} Days</span>
                <p style={{ color: '#4c5f56', fontSize: '20px' }} className="text-left seorgesb mb-0">
                  {t('From ')}
                  <span className="seorgesb ps-2" style={{ color: '#4c5f56' }}>
                    $
                    <span>
                      {typeof data?.suggested_tour_data !== 'undefined'
                        ? data?.suggested_tour_data?.basis_price
                        : min_price_grouptour}
                    </span>
                    <span>USD </span>
                  </span>
                </p>
              </div>
            </div>
            <Row>
              <Col className="position-relative" sm={7}>
                <div id="itinerarySection">
                  <p style={styles.font_size_30} className="text-left test pt-4 mt-1">
                    {t('Itinerary ')}
                  </p>
                  {data?.days.map((day, index) => (
                    <div key={index}>
                      <p style={{ color: '#4f4f4f', fontSize: '23px' }} className="text-left ps-3 mt-3 seorgesb">
                        <span style={{ color: '#511221', fontSize: '23px' }}>
                          {t('Day ')} {index + 1}
                        </span>
                        <span className="ms-5">{day.title}</span>
                      </p>
                      <p className="text-left ps-3 seorgesb">{day.note}</p>

                      {typeof day.night_region_name !== 'undefined' && typeof day.region_name !== 'undefined' && (
                        <p className="text-left ps-3 mt-1  seorgesb">
                          <span>{t('Region ')}: </span>
                          <span className="seorge">
                            {day.night_region_name === null && day.region_name.name}
                            {day.night_region_name !== null && day.night_region_name.name}
                          </span>
                        </p>
                      )}

                      {day.accommodation != null && (
                        <Fragment>
                          <div className="text-editor">
                            <p className="text-left ps-3 mt-1  seorgesb">
                              <span>{t('Accommodation ')}: </span>

                              {day.accommodation_name === 'Hospital' ||
                              day.accommodation_name === 'Night train' ||
                              day.accommodation_name === 'Undefined' ||
                              day.accommodation_name === 'Transfer to Airport' ||
                              day.accommodation_name === 'Arrival at home' ||
                              day.accommodation_name === 'Evening departure flight' ||
                              day.accommodation_name === 'Evening transfer to Airport' ||
                              day.accommodation_name === 'Morning departure flight' ||
                              day.accommodation_name === 'Wild camping' ? (
                                <span className="seorge"> {day.accommodation_name}</span>
                              ) : (
                                <span className="seorge">{day.accommodation_name}</span>
                              )}
                            </p>
                          </div>
                        </Fragment>
                      )}
                    </div>
                  ))}
                  <div style={{ height: '50px' }} id="services" />
                  {data?.included_services && data?.included_services.length > 0 && (
                    <p style={styles.font_size_30} className="text-left test ">
                      {t("What's Included ")}
                    </p>
                  )}
                  <br />
                  {typeof data?.included_services !== 'undefined' &&
                    data?.included_services.map((included, index) => (
                      <p className="text-left  ps-5 seorgesb" key={index}>
                        <span style={styles.color}>
                          <BiSolidCircle size={20} className="me-2" />
                        </span>
                        {t(included.note)}
                      </p>
                    ))}
                  <br />
                  <br />
                  {data?.excluded_services && data?.excluded_services?.length > 0 && (
                    <p style={styles.font_size_30} className="text-left test">
                      {t("What's Excluded ")}
                    </p>
                  )}
                  <br />
                  {typeof data?.excluded_services !== 'undefined' &&
                    data?.excluded_services.map((excluded, index) => (
                      <p className="text-left  ps-5 seorgesb" key={index}>
                        <span style={styles.color}>
                          <BiSolidCircle className="me-2" />
                        </span>
                        {t(excluded.note)}
                      </p>
                    ))}
                  <br />
                  <br />
                  {data?.available_extra_services && data?.available_extra_services?.length > 0 && (
                    <p style={styles.font_size_30} className="text-left test">
                      {t('Available extras ')}
                      <span className="ml-2 seorge" style={styles.font_size_16}>
                        {t(
                          '(Available options that can be added to included services - You should remind us any extras) '
                        )}
                      </span>
                    </p>
                  )}
                  <br />
                  {typeof data?.available_extra_services !== 'undefined' &&
                    data?.available_extra_services.map((extra, index) => (
                      <p className="text-left  ps-5 seorgesb" key={index}>
                        <span style={styles.color}>
                          <BiSolidCircle className="me-2" />
                        </span>
                        {t(extra.note)}
                      </p>
                    ))}
                </div>
              </Col>

              <Col sm={5} xs={12}>
                <div className="position-sticky" style={{ top: 150 }}>
                  <Image
                    className="tw-w-full mb-4"
                    alt=""
                    src={'https://api.iranjourney.com' + data?.map}
                    width={451}
                    height={415}
                    sizes="100vw"
                    style={{ objectFit: 'cover' }}
                  />
                  <br />
                  <Link className="px-3 btn-timnak btn tw-w-full tw-mb-3" href={'/tailor-made-iran-tours'}>
                    {t('Make it a private tour ')}
                  </Link>
                  <p className="mt-1">
                    {t(
                      'Customize this tour with your own departure, your own favorite accommodation, attraction list, and activity for your own group, family, or for you as a solo traveler. '
                    )}
                  </p>

                  <div className="text-center mt-3">
                    <Link style={styles.font_size_25} className="seorge btn btn-timnak" href={'/contact-us'}>
                      Ask a question
                    </Link>
                  </div>
                </div>
              </Col>
            </Row>
          </div>

          {typeof data?.group_tours !== 'undefined' && data?.group_tours.length !== 0 && (
            <Fragment>
              <br id="departures" />
              <p style={styles.font_size_30} className="text-left test pt-5">
                {t('Departures ')}
              </p>

              <br />

              <Table className="tour_table table-stripped d-md-table d-none" hover>
                <thead>
                  <tr style={{ background: '#dbdbdb', pointerEvents: 'none' }}>
                    <th>{t('Start - End ')}</th>
                    <th>{t('Booking before ')}</th>
                    <th>{t('Remaining Seats ')}</th>
                    <th>{t('Price Per Person in USD ')}</th>
                  </tr>
                </thead>
                <tbody>
                  {intervals.map((interval, index) => {
                    return (
                      <React.Fragment key={index}>
                        <tr>
                          <td style={{ background: 'white' }} colSpan={5} className="py-1">
                            <p style={{ fontSize: 22 }} className="seorgesb text-left mb-0">
                              {/* {moment(interval, 'YYYY-MM-DD').toString()} */}
                              {moment(new Date(Date.parse(interval)).toISOString()).format('MMM YYYY')}
                              {/* {moment(new Date(interval)).format('MM/DD/YYYY')} */}
                            </p>
                          </td>
                        </tr>
                        {groupTours[index].map((groupTour, idx) => {
                          return (
                            <tr key={idx}>
                              <td
                                style={
                                  idx === 0
                                    ? {
                                        color: '#343434',
                                        fontSize: '19px',
                                        borderTop: 'none',
                                      }
                                    : {
                                        color: '#343434',
                                        fontSize: '19px',
                                      }
                                }
                                className="seorgesb"
                              >
                                {groupTour.start_date} -
                                {moment(groupTour.start_date)
                                  .add(data?.days.length - 1, 'days')
                                  .format('MMM. D, yyyy')}
                              </td>
                              <td
                                style={
                                  idx === 0
                                    ? {
                                        color: '#343434',
                                        fontSize: '19px',
                                        borderTop: 'none',
                                      }
                                    : {
                                        color: '#343434',
                                        fontSize: '19px',
                                      }
                                }
                                className="seorgesb"
                              >
                                {moment(groupTour.booking_deadline).format('MMM. D, yyyy')}
                              </td>
                              <td
                                style={
                                  idx === 0
                                    ? {
                                        color: '#343434',
                                        fontSize: '19px',
                                        borderTop: 'none',
                                      }
                                    : {
                                        color: '#343434',
                                        fontSize: '19px',
                                      }
                                }
                                className="seorgesb"
                              >
                                {groupTour.group_size}+
                              </td>

                              <td
                                style={
                                  idx === 0
                                    ? {
                                        color: '#343434',
                                        fontSize: '19px',
                                        borderTop: 'none',
                                      }
                                    : {
                                        color: '#343434',
                                        fontSize: '19px',
                                      }
                                }
                              >
                                <Link href={`/tailor-made-iran-tours?code=${groupTour.departure_code}`}>
                                  <button
                                    // onClick={() => setFirstModal(true)}
                                    style={{
                                      color: 'white',
                                      background: '#521231',
                                      fontWeight: '600',
                                      fontSize: '19px',
                                    }}
                                    className="btn px-4"
                                  >
                                    {groupTour.price}
                                  </button>
                                </Link>
                              </td>
                            </tr>
                          );
                        })}
                      </React.Fragment>
                    );
                  })}
                </tbody>
              </Table>

              <div className="mock-table d-md-none d-block">
                {intervals.map((interval, index) => {
                  return (
                    <div key={index}>
                      <div style={{ background: 'white' }} className="py-1 mb-2">
                        <p style={{ fontSize: 22 }} className="seorgesb text-left ps-2 mb-0">
                          {moment(new Date(Date.parse(interval)).toISOString()).format('MMM YYYY')}
                        </p>
                      </div>
                      {groupTours[index].map((groupTour, idx) => {
                        return (
                          <div className="mock-table-row" key={idx}>
                            <div className=" mb-2 ps-2">
                              <b style={{ fontWeight: 800 }}>{t('Start - End ')}: </b>
                              <span className="seorgesb">
                                {groupTour.start_date} -
                                {moment(groupTour.start_date)
                                  .add(data?.days.length - 1, 'days')
                                  .format('MMM. D, yyyy')}
                              </span>
                            </div>
                            <div className=" mb-2 ps-2">
                              <b style={{ fontWeight: 800 }}>{t('Booking before ')}: </b>
                              <span className="seorgesb">
                                {moment(groupTour.booking_deadline).format('MMM. D, yyyy')}
                              </span>
                            </div>
                            <div className=" d-flex align-items-center justify-content-between mb-2 ps-2">
                              <div>
                                <b style={{ fontWeight: 800 }}>{t('Remaining Seats ')}: </b>
                                <span className="seorgesb">{groupTour.group_size}+ </span>
                              </div>
                              <Link href={'/tailor-made-iran-tours'}>
                                <button
                                  // onClick={() => setFirstModal(true)}
                                  style={{
                                    color: 'white',
                                    background: '#521231',
                                    fontWeight: '600',
                                    fontSize: '19px',
                                  }}
                                  className="btn px-4"
                                >
                                  {groupTour.price}
                                </button>
                              </Link>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  );
                })}
              </div>
            </Fragment>
          )}
        </Container>

        <div className="text-center my-5 px-5">
          <Link href={'/Tailor-made-Iran-tours'}>
            <Button
              className="seorge px-5 py-4 mt-1 button-fill-down hover:tw-bg-orange-400"
              style={{
                background: 'white',
                color: '#521231',
                fontSize: '30px',
                borderRadius: '8px',
                border: 'none',
              }}
            >
              {t('Customize your own trip ')}
            </Button>
          </Link>
        </div>

        <MyVerticallyCenteredModalFirst show={first_modal} onHide={() => setFirstModal(false)} />
        <MyVerticallyCenteredModal show={modalShow} onHide={() => setModalShow(false)} />
        <MyVerticallyCenteredModal2 show={modalShow2} onHide={() => setModalShow2(false)} />

        <div className="mb-3">
          <Section3 />
        </div>
      </React.Fragment>

      {/* Gallery modal */}
      <Modal show={galleryModal} onHide={() => setGalleryModal(false)} size="lg">
        <Modal.Header closeButton>Gallery</Modal.Header>
        <Modal.Body>
          <Carousel>
            {tourAddRetrieve.isSuccess &&
              tourAddRetrieve.data?.tour_pic_list &&
              tourAddRetrieve.data?.tour_pic_list[0] &&
              tourAddRetrieve.data?.tour_pic_list[0].image_1 && (
                <Carousel.Item>
                  <img
                    src={`https://api.iranjourney.com/${tourAddRetrieve.data?.tour_pic_list[0].image_1}`}
                    className="img-fluid"
                  />
                </Carousel.Item>
              )}
            {tourAddRetrieve.isSuccess &&
              tourAddRetrieve.data?.tour_pic_list &&
              tourAddRetrieve.data?.tour_pic_list[0] &&
              tourAddRetrieve.data?.tour_pic_list[0].image_2 && (
                <Carousel.Item>
                  <img
                    src={`https://api.iranjourney.com/${tourAddRetrieve.data?.tour_pic_list[0].image_2}`}
                    className="img-fluid"
                  />
                </Carousel.Item>
              )}
            {tourAddRetrieve.isSuccess &&
              tourAddRetrieve.data?.tour_pic_list &&
              tourAddRetrieve.data?.tour_pic_list[0] &&
              tourAddRetrieve.data?.tour_pic_list[0].image_3 && (
                <Carousel.Item>
                  <img
                    src={`https://api.iranjourney.com/${tourAddRetrieve.data?.tour_pic_list[0].image_3}`}
                    className="img-fluid"
                  />
                </Carousel.Item>
              )}
            {tourAddRetrieve.isSuccess &&
              tourAddRetrieve.data?.tour_pic_list &&
              tourAddRetrieve.data?.tour_pic_list[0] &&
              tourAddRetrieve.data?.tour_pic_list[0].image_4 && (
                <Carousel.Item>
                  <img
                    src={`https://api.iranjourney.com/${tourAddRetrieve.data?.tour_pic_list[0].image_4}`}
                    className="img-fluid"
                  />
                </Carousel.Item>
              )}
            {tourAddRetrieve.isSuccess &&
              tourAddRetrieve.data?.tour_pic_list &&
              tourAddRetrieve.data?.tour_pic_list[0] &&
              tourAddRetrieve.data?.tour_pic_list[0].image_5 && (
                <Carousel.Item>
                  <img
                    src={`https://api.iranjourney.com/${tourAddRetrieve.data?.tour_pic_list[0].image_5}`}
                    className="img-fluid"
                  />
                </Carousel.Item>
              )}
            {tourAddRetrieve.isSuccess &&
              tourAddRetrieve.data?.tour_pic_list &&
              tourAddRetrieve.data?.tour_pic_list[0] &&
              tourAddRetrieve.data?.tour_pic_list[0].image_6 && (
                <Carousel.Item>
                  <img
                    src={`https://api.iranjourney.com/${tourAddRetrieve.data?.tour_pic_list[0].image_6}`}
                    className="img-fluid"
                  />
                </Carousel.Item>
              )}
            {tourAddRetrieve.isSuccess &&
              tourAddRetrieve.data?.tour_pic_list &&
              tourAddRetrieve.data?.tour_pic_list[0] &&
              tourAddRetrieve.data?.tour_pic_list[0].image_7 && (
                <Carousel.Item>
                  <img
                    src={`https://api.iranjourney.com/${tourAddRetrieve.data?.tour_pic_list[0].image_7}`}
                    className="img-fluid"
                  />
                </Carousel.Item>
              )}
            {tourAddRetrieve.isSuccess &&
              tourAddRetrieve.data?.tour_pic_list &&
              tourAddRetrieve.data?.tour_pic_list[0] &&
              tourAddRetrieve.data?.tour_pic_list[0].image_8 && (
                <Carousel.Item>
                  <img
                    src={`https://api.iranjourney.com/${tourAddRetrieve.data?.tour_pic_list[0].image_8}`}
                    className="img-fluid"
                  />
                </Carousel.Item>
              )}
            {tourAddRetrieve.isSuccess &&
              tourAddRetrieve.data?.tour_pic_list &&
              tourAddRetrieve.data?.tour_pic_list[0] &&
              tourAddRetrieve.data?.tour_pic_list[0].image_9 && (
                <Carousel.Item>
                  <img
                    src={`https://api.iranjourney.com/${tourAddRetrieve.data?.tour_pic_list[0].image_9}`}
                    className="img-fluid"
                  />
                </Carousel.Item>
              )}
            {tourAddRetrieve.isSuccess &&
              tourAddRetrieve.data?.tour_pic_list &&
              tourAddRetrieve.data?.tour_pic_list[0] &&
              tourAddRetrieve.data?.tour_pic_list[0].image_10 && (
                <Carousel.Item>
                  <img
                    src={`https://api.iranjourney.com/${tourAddRetrieve.data?.tour_pic_list[0].image_10}`}
                    className="img-fluid"
                  />
                </Carousel.Item>
              )}
            {tourAddRetrieve.isSuccess &&
              tourAddRetrieve.data?.tour_pic_list &&
              tourAddRetrieve.data?.tour_pic_list[0] &&
              tourAddRetrieve.data?.tour_pic_list[0].image_11 && (
                <Carousel.Item>
                  <img
                    src={`https://api.iranjourney.com/${tourAddRetrieve.data?.tour_pic_list[0].image_11}`}
                    className="img-fluid"
                  />
                </Carousel.Item>
              )}
            {tourAddRetrieve.isSuccess &&
              tourAddRetrieve.data?.tour_pic_list &&
              tourAddRetrieve.data.tour_pic_list[0] &&
              tourAddRetrieve.data.tour_pic_list[0].image_12 && (
                <Carousel.Item>
                  <img
                    src={`https://api.iranjourney.com/${tourAddRetrieve.data.tour_pic_list[0].image_12}`}
                    className="img-fluid"
                  />
                </Carousel.Item>
              )}
            {tourAddRetrieve.isSuccess &&
              tourAddRetrieve.data.tour_pic_list &&
              tourAddRetrieve.data.tour_pic_list[0] &&
              tourAddRetrieve.data.tour_pic_list[0].image_13 && (
                <Carousel.Item>
                  <img
                    src={`https://api.iranjourney.com/${tourAddRetrieve.data.tour_pic_list[0].image_13}`}
                    className="img-fluid"
                  />
                </Carousel.Item>
              )}
            {tourAddRetrieve.isSuccess &&
              tourAddRetrieve.data.tour_pic_list &&
              tourAddRetrieve.data.tour_pic_list[0] &&
              tourAddRetrieve.data.tour_pic_list[0].image_14 && (
                <Carousel.Item>
                  <img
                    src={`https://api.iranjourney.com/${tourAddRetrieve.data.tour_pic_list[0].image_14}`}
                    className="img-fluid"
                  />
                </Carousel.Item>
              )}
            {tourAddRetrieve.isSuccess &&
              tourAddRetrieve.data.tour_pic_list &&
              tourAddRetrieve.data.tour_pic_list[0] &&
              tourAddRetrieve.data.tour_pic_list[0].image_15 && (
                <Carousel.Item>
                  <img
                    src={`https://api.iranjourney.com/${tourAddRetrieve.data.tour_pic_list[0].image_15}`}
                    className="img-fluid"
                  />
                </Carousel.Item>
              )}
          </Carousel>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Client;
